<template>
  <div class="stock-opname-detail">
    <div v-if="isDataReady">
      <div
        v-for="(pageItems, pageIndex) in paginatedDetails"
        :key="pageIndex"
        class="stock-opname-page"
      >
        <ReceiptHeader type="outlet" :data="outlet" />
        <div class="title-section">
          <div class="main-title">LAPORAN STOK OPNAME OUTLET</div>
        </div>
        <div class="p-grid">
          <div class="p-col-3">
            <label for="">Status</label>
            <div class="sub-title">{{ stock_opname.status }}</div>
          </div>
          <div class="p-col-3">
            <label for="">Waktu Mulai</label>
            <div class="sub-title">{{ stock_opname.start | dateTime }}</div>
          </div>
          <div class="p-col-3">
            <label for="">Total Kekurangan</label>
            <div class="sub-title">
              {{ stock_opname.deficiency_total | number }}
            </div>
          </div>
          <div class="p-col-3">
            <label for="">Total Kelebihan</label>
            <div class="sub-title">
              {{ stock_opname.excess_total | number }}
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-3"></div>
          <div class="p-col-3">
            <label for="">Waktu Selesai</label>
            <div class="sub-title">{{ stock_opname.end | dateTime }}</div>
          </div>
          <div class="p-col-3">
            <label for="">Nilai Kekurangan</label>
            <div class="sub-title">
              {{ stock_opname.deficiency_value | currency }}
            </div>
          </div>
          <div class="p-col-3">
            <label for="">Nilai Kelebihan</label>
            <div class="sub-title">
              {{ stock_opname.excess_value | currency }}
            </div>
          </div>
        </div>
        <div class="p-mt-5">
          <table class="detail-bon">
            <thead>
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Selisih</th>
                <th>Harga Ganti</th>
                <th>Jumlah Ganti</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, k) in pageItems" :key="k">
                <td>{{ pageIndex * 25 + k + 1 }}</td>
                <td>{{ item.item_code }}</td>
                <td>{{ item.item_name }}</td>
                <td>
                  <span v-if="item.type === 'DEFICIENCY'"
                    >- {{ item.difference }}</span
                  >
                  <span v-else>{{ item.difference }}</span>
                </td>
                <td>{{ item.replacement_price | number }}</td>
                <td>{{ item.total_replacement_price | number }}</td>
              </tr>
              <tr v-if="pageIndex + 1 === paginatedDetails.length">
                <td colspan="5"></td>
                <td>{{ stock_opname.total_replacement_price | number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
import { mapState } from 'vuex'

export default {
  components: {
    ReceiptHeader
  },
  computed: {
    ...mapState(['user', 'isAuthenticated']),
    paginatedDetails() {
      const perPage = 25
      const pages = []
      for (let i = 0; i < this.stock_opname_detail.length; i += perPage) {
        pages.push(this.stock_opname_detail.slice(i, i + perPage))
      }
      return pages
    }
  },
  data() {
    return {
      stock_opname: null,
      stock_opname_detail: [],
      outlet: null,
      isDataReady: false
    }
  },
  mounted() {
    this.getOutlet()
    window.addEventListener('afterprint', this.handleAfterPrint)
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },
  methods: {
    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.$route.query.outlet_id}`
        )
        if (response.status === 200) {
          this.outlet = response.data.data.outlets
          this.getReview()
        }
      } catch (error) {
        console.error('Error fetching outlet data:', error)
      }
    },
    async getReview() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/pos/stock-opname/${this.$route.query.id}?limit=${this.$route.query.total}&page=1`
        )
        if (response.status === 200) {
          let data_opname_detail = response.data.data
          this.stock_opname = data_opname_detail.stock_opname
          this.stock_opname_detail = data_opname_detail.stock_opname_detail
          this.isDataReady = true
          this.$nextTick(() => {
            setTimeout(() => {
              window.print()
            }, 500)
          })
        }
      } catch (error) {
        console.error('Error fetching review data:', error)
      }
    },
    handleAfterPrint() {
      window.close()
    }
  }
}
</script>

<style scoped>
.stock-opname-detail {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
  font-family: inherit;
}
.stock-opname-page {
  page-break-after: always;
  page-break-inside: avoid;
}
.stock-opname-page:last-child {
  page-break-after: auto;
}
.border-header {
  border-top: 2px solid black;
  width: 100%;
  margin-top: -3.5vh;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}
.image {
  margin-left: -40px;
  width: 65px;
}
.title-section {
  text-align: center;
  margin-bottom: 1rem;
}
.main-title {
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 0.25rem;
}
.subtitle {
  font-size: 1rem;
  color: #555;
}
.detail-bon {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  font-size: 12px;
  margin-left: auto;
  margin-right: auto;
}
.detail-bon th,
.detail-bon td {
  border: 1px solid #000;
  padding: 8px 6px;
  text-align: center;
}
.detail-bon th {
  background-color: #f0f0f0;
  font-weight: 600;
}
.detail-bon tbody tr:nth-child(odd) {
  background-color: #fff;
}
.detail-bon tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}
</style>
